import { PropsWithChildren } from 'react'

import { Box, Stack, Typography } from '@mui/material'

import { colors } from 'app/theme'

const style = {
  backgroundColor: colors.dialogueLinen,
  borderRadius: 4,
  marginBottom: '2.5rem',
  boxShadow: '0px 2px 4px 0px #F1F1F1',
}

export const Banner = ({ children }: PropsWithChildren) => (
  <Box style={style} padding={2} data-testid="banner-container">
    <Stack direction="row" justifyContent="center" alignItems="center" data-testid="banner-stack">
      <Typography variant="subtitle2" align="center" data-testid="banner-text">
        {children}
      </Typography>
    </Stack>
  </Box>
)
